import React, { useState, useEffect } from "react"

import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import AlertBox from './AlertBox'
import $ from 'jquery';
import frm from './formAux.js'



/*
https://labeling-datasets.s3.ap-south-1.amazonaws.com/output/Home-Appliance-Job-3/manifests/output/output.manifest
s3://labeling-datasets/output/kitti-bounding-box-audit/manifests/output/output.manifest
*/

function AccountSettings(prop) {
    var global = window.GlobalVars;
    useEffect( function(a){
        $('#name').val( global.userName || '' );
        if( global.userRedefinePassword )
        {
            // $('#newpass').attr('placeholder', $('#newpass').attr('placeholder') + ' (optional)' );
            // $('#newpass2').attr('placeholder', $('#newpass2').attr('placeholder') + ' (optional)' );
            // $('h3').html('Account Settings - Password Change is Required')
            window.alertBox('Password Change is Required', 'ok');
            $('#newpass').attr('placeholder', $('#newpass').attr('placeholder') );
            $('#newpass2').attr('placeholder', $('#newpass2').attr('placeholder') );
        }
        if( global.userRedefinePassword == 1 ) { 
            $('#oldpass').hide();
            $('#oldpasslabel').hide();
        }
        if( window.hasPriv( 'api' ) )
        {
            $('.account-api').html(`
                <h4 class="acchead mb-4">API Key</h4>
                <div class="alert alert-info" id="apialert"></div>
                <div class="account-api-key">...</div>
                <Button type="submit" class="btn btn-primary mt-2" id="apigenbut">Create New API Key</Button>
                <Button type="submit" class="btn btn-danger mt-2" id="apidelbut">Delete API Key</Button>
                `);
            $('#apialert').hide();
            var noKey = '<i>No API Key set for this user</i>';
            window.post( 'get_api_key', {}, res => {
                var key = res.data;
                if( !key ) key = noKey;
                $('.account-api-key').html(key)
            } )
            $('#apigenbut').on('click', function(){
                window.post( 'gen_api_key', {}, res => {
                    var key = res.data;
                    $('#apialert').show().html('<strong>IMPORTANT: Save this key!</strong><br>Please copy the key below. This information wont be recoverable in future sessions.');
                    var htmlKey = key + ' <i title="copy to clipboard" class="fa fa-copy copy-icon"></i>';

                    $('.account-api-key').html(htmlKey)
                    $('.copy-icon').on('click', function(){
                        frm.saveClipboard(key);
                        frm.myAlert( 'Key Copied', 'The key was copied to your clipboard', 'Ok')
                        setTimeout( function(){
                            frm.myAlertClose();
                        }, 5000 )
                    })
                } )
            })
            $('#apidelbut').on('click', function(){
                window.post( 'gen_api_key', {del:true}, res => {
                    $('#apialert').hide();
                    var key = res.data;
                    if( !key ) key = noKey;
                    $('.account-api-key').html(key)
                } )
            })
        }
    })

    window.setNavActive('accountSettings');
    function submit(ev)
    {
        console.log( 'submit' )
        ev.preventDefault();
        window.alertOut();
        var name = $('#name').val().trim();
        var oldpass = $('#oldpass').val().trim();
        var pass = $('#newpass').val().trim();
        var pass2 = $('#newpass2').val().trim();

        if( name == '' )
        {
            window.alertBox('Please type your full Name', 'err');
            $('#name').focus();
            return;
        }
        if( !global.userRedefinePassword && oldpass == '' )
        {
            window.alertBox('Please enter your current password', 'err');
            $('#oldpass').focus();
            return;
        }

        if( global.userRedefinePassword && pass.length == 0 )
        {
            window.alertBox('Please type your new password', 'err');
            return cleanPass();
        }

        if( pass.length > 0 && pass != pass2 )
        {
            window.alertBox('Password mismatch. The new password and confirm password must be an identical.', 'err');
            return cleanPass();
        }
        

        function cleanPass()
        {
            $('#newpass2').val('');
            $('#newpass').val('').focus();
        }
        function formError( error )
        {
            var errs = [];
            if( typeof(error) == 'string' ) error = [error];
            var focus = null;
            for( var e in error )
            {
                $('#'+e).val('');
                if( !focus ) $('#'+e).focus();
                errs.push(error[e]);
            }
            console.log('errsp', errs)
            window.alertBox( errs.join('<br/>'), 'err' );

        }
        window.alertBox('Changing Password', 'loading')
        window.post('account_update',{name:name,oldpass:oldpass,newpass:pass}, function(r){
            r = r.data;
            console.log( 'change', r )
            if( r.error || !r.status )
            {
                return formError( r.error || r.value )
            }
            global.userName = name;
            window.saveSession();
            setTimeout( function(){
                document.location = '#Projects';
                document.location.reload();
            }, 1000 );
            window.alertBox('Success! Your details have been updated successfully.', 'ok');
            $('.forminpt').val('');
            return;
            if( global.userRedefinePassword )
            {
                global.userRedefinePassword = false;
                window.saveSession();
                setTimeout( function(){
                    document.location = '#';
                    document.location.reload();
                }, 2000 );
            }
        })
    }

    return (
        <Container fluid="md mt-4 accset"> 
        {/* <div className="acc2 accset md mt-4"> */}
        <div className="account-pass">
         <Form className="mr-4" method="GET"  onSubmit={submit}>                  {/*added mr-4 here */}
            <div className="acchead">
            <Form.Label><h4>User Settings</h4></Form.Label>
            </div>
            <AlertBox/>
            <Form.Label><h6  className="acclabel">User Name</h6></Form.Label>
            <Form.Control className="mb-4" placeholder="Full Name" type="text" id="name"/>
            <Form.Label><h6 className="acclabel" id='oldpasslabel'>Current Password</h6></Form.Label>
            <Form.Control className="mb-4 forminpt" placeholder="Current Password" type="password" id="oldpass"/>
            {/* { !global.userRedefinePassword &&
             (  <>
                    <Form.Label><h6 className="acclabel">Old Password</h6></Form.Label>
                </>
            )}
            <Form.Control className="mb-4 forminpt" placeholder="Old Password" type="password" id="oldpass"/>
            { global.userRedefinePassword && 
            (   <>
                    <Form.Label><h6 className="acclabel">New Password</h6></Form.Label>
                </> 
            )} */}
            <Form.Label><h6 className="acclabel">New Password</h6></Form.Label>
            <Form.Control className="mb-4 forminpt" placeholder="New Password" type="password" id="newpass"/>
            <Form.Label><h6 className="acclabel">Confirm Password</h6></Form.Label>
            <Form.Control className="mb-4 forminpt" placeholder="Retype New Password" type="password" id="newpass2"/>
            <Button variant="primary" type="submit" className="mt-2">Save Changes</Button>
        </Form>
        </div>
        <div className="account-api">

        </div>
        {window.hasPriv && window.hasPriv('c_admin', 'admin') && (
            <div className="account-assessment-api mt-4">
                <h4 className="acchead mb-3">Assessment API key</h4>
                <p className="text-muted mb-3">Manage API keys for Assessment API integration</p>
                <Button variant="primary" onClick={() => window.goPage && window.goPage('bcmApiKeys')}>
                    <i className="fa fa-key me-2"></i>{" "}Manage Assessment API keys
                </Button>
            </div>
        )}
        {/* </div> */}
         </Container>
    )
}

export default AccountSettings
